module.exports = __webpack_public_path__ + "img/7.61108b7f.jpg";